module.exports = __webpack_public_path__ + "img/bgbottom3x.32bc5e3d.png";